import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent, KEYS } from '../../../shared/index.js';
import Icon from '../../base/Icon/Icon.js';
import Translate from '../../base/Translate/Translate.js';

import { IDocumentTileConfiguration, IDocumentTileProps, IDocumentTileState } from './models/index.js';
import Label from './styledComponents/Label.js';
import Wrapper from './styledComponents/Wrapper.js';
import { DOCUMENT_TILE_CATEGORY_KEY, DOCUMENT_TILE_COMPONENT_KEY } from './DocumentTile.meta.js';

const ACCEPT_KEYS: string[] = [KEYS.ENTER, KEYS.SPACE, KEYS.SPACEBAR];

export class DocumentTile extends ComponentBase<IDocumentTileProps, IDocumentTileState, IDocumentTileConfiguration> {
	categoryKey = DOCUMENT_TILE_CATEGORY_KEY;
	componentKey = DOCUMENT_TILE_COMPONENT_KEY;
	spinnerAssetKey = 'file.documentTile.spinner';

	isDownloading = false;
	constructor(props: IDocumentTileProps) {
		super(props);

		makeObservable(this, {
			isDownloading: observable,
			handleClick: action,
		});
	}
	handleClick = async () => {
		const { document, fileName, onClick } = this.props;
		if (document && onClick) {
			this.isDownloading = true;
			await onClick(document, fileName);
			this.isDownloading = false;
		}
	};
	render() {
		const {
			className,
			label,
			iconPosition = 'before',
			iconProps,
			iconAssetKey = 'file.documentTile.icon',
			useSpinner = true,
		} = this.props;
		const iconAsset = this.isDownloading && useSpinner ? this.spinnerAssetKey : iconAssetKey;
		const icon = <Icon {...iconProps} asset={iconAsset} />;
		return (
			<Wrapper
				className={className}
				onClick={this.handleClick}
				role="button"
				tabIndex={0}
				onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
					ACCEPT_KEYS.indexOf(e.key) >= 0 && this.handleClick && this.handleClick()
				}
			>
				{iconPosition === 'before' && icon}
				<Label>
					<Translate>{label}</Translate>
				</Label>
				{iconPosition === 'after' && icon}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(DocumentTile), DOCUMENT_TILE_CATEGORY_KEY, DOCUMENT_TILE_COMPONENT_KEY);
